export default __webpack_public_path__ + "static/media/paypal.e3abf7de.png";